import { render, staticRenderFns } from "./ProfitDaily.vue?vue&type=template&id=ff2f88da&scoped=true&"
import script from "./ProfitDaily.vue?vue&type=script&lang=js&"
export * from "./ProfitDaily.vue?vue&type=script&lang=js&"
import style0 from "./ProfitDaily.vue?vue&type=style&index=0&id=ff2f88da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f88da",
  null
  
)

export default component.exports